import styled from "styled-components";
import { colors } from "theme";

export const UploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
  position: relative;
`;
export const DownloadButton = styled.div`
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.accentColor};
  border-radius: 5px;
  /* margin: 24px 0px 24px 0px; */
  padding: 20px;
  cursor: pointer;
  &:hover {
    transition: transform 0.2s ease-in-out;
    transform: scale(1.005);
  }
  max-width: 40%;
`;

export const Label = styled.div`
  font-family: "Montserrat";
  color: ${() => colors.primaryColor};
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 33px;
`;

export const UploadButton = styled.div`
  display: flex;
  cursor: pointer;
  /* margin-top: 24px; */
  border: 1px solid #231a3d;
  /* box-shadow: 0px 0px 6px rgba(74, 74, 74, 0.19); */
  border-radius: 10px;
  padding: 58px;
  justify-content: center;
  /* cursor: pointer; */
  &:hover {
    transition: transform 0.2s ease-in-out;
    background-color: #f9fcff;
    transform: scale(1.005);
  }

  & > input {
    display: none;
  }
`;

export const UploadButtonGlassEffect = styled.div`
  display: flex;
  cursor: pointer;
  /* margin-top: 24px; */
  /* border: 1px solid #231a3d; */
  /* box-shadow: 0px 0px 6px rgba(74, 74, 74, 0.19); */
  border: 1px solid rgba(255, 255, 255, 1);
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  padding: 58px;
  justify-content: center;
  display: flex;
  align-items: center;
  justify-content: center;

  /* cursor: pointer; */
  &:hover {
    transition: transform 0.2s ease-in-out;
    /* background-color: #f9fcff; */
    transform: scale(1.005);
  }

  & > input {
    display: none;
  }
`;


export const Error = styled.p`
  color: red;
  font-size: 10px;
  /* bottom: ${(props) => (props.bottom ? props.bottom : "-1.4rem")}; */
  z-index: 9;
  margin-left: 0.2rem;
  bottom: 1rem;
font-family: 'Montserrat';
  position: absolute;
`;
